<template>
  <div class="info-page">
    <!-- Hero -->
    <section class="info-hero text-center">
      <div class="container">
        <p class="info-hero__eyebrow">{{ $t('telehealth.eyebrow') }}</p>
        <h1 class="info-hero__title">{{ $t('telehealth.title') }}</h1>
        <p class="info-hero__intro">{{ $t('telehealth.intro') }}</p>
        <div class="info-hero__states">
          <span v-for="state in states" :key="state" class="info-state-pill">{{ state }}</span>
        </div>
      </div>
    </section>

    <!-- Content -->
    <section class="wl-section" style="background: var(--wl-bg);">
      <div class="container">
        <div class="row">
          <div class="col-lg-10 mx-auto">
            <div class="wl-card info-card p-4 p-md-5">
              <div class="d-flex align-items-center mb-3">
                <i class="bi bi-camera-video info-card__icon me-3"></i>
                <h2 class="info-card__heading mb-0">{{ $t('footer.availabilityTitle') }}</h2>
              </div>
              <p class="info-card__body mb-0">{{ $t('footer.serviceAvailability') }}</p>
            </div>

            <p class="info-note text-center mt-4">{{ $t('telehealth.note') }}</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'TelehealthServicesPage',
  data() {
    return {
      states: ['FL', 'MA', 'NJ', 'NY', 'CT']
    };
  }
}
</script>

<style scoped>
.info-hero {
  background: var(--wl-grad-dark);
  padding: 80px 0 110px;
}
.info-hero__eyebrow {
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 14px;
  font-weight: 600;
  color: #aeeaff;
  margin-bottom: 10px;
}
.info-hero__title {
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  color: #fff;
  margin-bottom: 16px;
}
.info-hero__intro {
  color: rgba(255, 255, 255, 0.9);
  max-width: 640px;
  margin: 0 auto;
  font-size: 18px;
  line-height: 1.6;
}
.info-hero__states {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  margin-top: 22px;
}
.info-state-pill {
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  font-weight: 600;
  font-size: 13px;
  letter-spacing: 1px;
  padding: 6px 16px;
  border-radius: 999px;
}
.info-card {
  margin-top: -70px;
  position: relative;
  z-index: 2;
}
.info-card__icon {
  font-size: 28px;
  color: var(--pool-700);
}
.info-card__heading {
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  color: var(--wl-navy);
  font-size: 22px;
}
.info-card__body {
  font-family: 'Inter', sans-serif;
  color: var(--wl-text);
  font-size: 16px;
  line-height: 1.8;
}
.info-note {
  color: var(--pool-800);
  font-size: 14px;
  font-style: italic;
}
</style>
